import { CommonModule, registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule } from '@angular/common/http';
import localeJa from '@angular/common/locales/ja';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { MessageTemplateCreatorModule } from './View/Shared/MessageTemplateCreator/MessageTemplateCreatorModule';
import { HtmlMailCreatorModule } from './View/Shared/HtmlMailCreator/HtmlMailCreatorModule';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

registerLocaleData(localeJa, 'ja');
@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		IonicModule.forRoot(),
		CommonModule,
		FormsModule,
		HttpClientModule,
		BrowserAnimationsModule,
		IonicStorageModule.forRoot(),
		CalendarModule.forRoot({
			provide: DateAdapter,
			useFactory: adapterFactory,
		}),
		MessageTemplateCreatorModule,
		HtmlMailCreatorModule,
		MatButtonModule,
		MatCardModule,
		MatFormFieldModule,
		MatOptionModule,
		MatRadioModule,
		MatSelectModule,
		MatIconModule,
		MatPaginatorModule,
		MatRippleModule,
		MatSortModule,
		MatTableModule
	],
	providers: [{ provide: 'injectData', useValue: null }],
	bootstrap: [AppComponent],
})
export class AppModule { }
